var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",class:_vm.wrapperClass},[_c('div',{staticClass:"d-inline-flex align-items-center text-muted"},[_c('AlertCircleOutlineIcon',{staticClass:"mr-1",attrs:{"size":"18"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }